import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDNLl36Gl5QO2bWOLjdBjuGzNoNupEeGzY",
  authDomain: "supersystemtestcrm.firebaseapp.com",
  projectId: "supersystemtestcrm",
  storageBucket: "supersystemtestcrm.firebasestorage.app",
  messagingSenderId: "671257775539",
  appId: "1:671257775539:web:f78db2e5174fae0e58cfc6",
  measurementId: "G-PQ28KW4CHW"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
